import './index.css';

import { Amplify } from 'aws-amplify';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import { amplifyConfig } from './config/amplify';

// Configure Amplify for Cognito auth
Amplify.configure(amplifyConfig);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
